import { TermsCategory } from '@/api/terms.types';
import useTermsContentsQuery from '../../../queries/hooks/useTermsContentsQuery';

export default function useLatestTermsContentUrl(
  category: TermsCategory,
  enabled: boolean,
) {
  const { data } = useTermsContentsQuery(category, enabled);

  if (!data) return '';

  return data?.terms.reduce((prev, current) =>
    prev.sortableDate > current.sortableDate ? prev : current,
  ).contentUrl;
}
